// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"iwe7c":[function(require,module,exports,__globalThis) {
/**
 * PWA & Mobile Installation Logic
 * Handles Android Install Prompt, iOS Instructions, and In-App Browser Detection.
 */ (function initPWA() {
    const installBtn = document.getElementById('pwaInstallBtn');
    const iosModal = document.getElementById('iosInstallModal');
    const closeIosModal = document.getElementById('closeIosModal');
    const inAppPopup = document.getElementById('inAppPopup');
    let deferredPrompt = null;
    // ===============================================
    // 1. Service Worker Registration
    // ===============================================
    if ('serviceWorker' in navigator) window.addEventListener('load', ()=>{
        // By masking the string from Parcel's static analyzer, we avoid the bundle conflict
        const swUrl = window.location.origin + '/sw.js';
        navigator.serviceWorker.register(swUrl).then((reg)=>console.log('SW Registered!', reg)).catch((err)=>console.log('SW Registration Failed', err));
    });
    // ===============================================
    // 2. Detection Utils
    // ===============================================
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    const isInApp = ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1 || ua.indexOf("Instagram") > -1;
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || navigator.standalone;
    // If not mobile or already installed, stop
    if (!isMobile || isStandalone) return;
    // ===============================================
    // 3. Show In-App Popup (on click only)
    // ===============================================
    function showInAppPopup() {
        if (inAppPopup) {
            inAppPopup.hidden = false;
            setTimeout(()=>{
                inAppPopup.hidden = true;
            }, 5000);
        }
    }
    // ===============================================
    // 4. Capture Android Install Event
    // ===============================================
    window.addEventListener('beforeinstallprompt', (e)=>{
        e.preventDefault();
        deferredPrompt = e;
        // Show install button when prompt is available
        if (installBtn) installBtn.style.display = 'inline-flex';
    });
    // ===============================================
    // 5. iOS: Show button directly (no beforeinstallprompt on iOS)
    // ===============================================
    if (isIOS && installBtn) installBtn.style.display = 'inline-flex';
    // ===============================================
    // 6. Single Click Handler (handles all platforms)
    // ===============================================
    if (installBtn) installBtn.addEventListener('click', async ()=>{
        // If in-app browser, show popup warning
        if (isInApp) {
            showInAppPopup();
            return;
        }
        // Android: Use the deferred prompt
        if (deferredPrompt) {
            try {
                deferredPrompt.prompt();
                const { outcome } = await deferredPrompt.userChoice;
                console.log(`User response: ${outcome}`);
            } catch (err) {
                console.log('Install prompt error:', err);
            }
            deferredPrompt = null;
            return;
        }
        // iOS: Show instruction modal
        if (isIOS && iosModal) {
            iosModal.hidden = false;
            iosModal.style.display = 'flex';
        }
    });
    // ===============================================
    // 7. Close iOS Modal
    // ===============================================
    if (closeIosModal && iosModal) {
        closeIosModal.addEventListener('click', ()=>{
            iosModal.hidden = true;
            iosModal.style.display = 'none';
        });
        window.addEventListener('click', (e)=>{
            if (e.target === iosModal) {
                iosModal.hidden = true;
                iosModal.style.display = 'none';
            }
        });
    }
})();

},{}]},["iwe7c"], "iwe7c", "parcelRequiref6cf", {})

//# sourceMappingURL=client.ecd22820.js.map
